// removed by extract-text-webpack-plugin
module.exports = {"app":"_3Lk6","rect":"_1fjB","drop":"_3YUe","screen":"_2iZA","panel":"_2lJh","state":"_1deS","bottom":"_8hag","gameIntro":"DolP","introTitle":"_3JOe","introContent":"_2rKr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/index.less
// module id = 245
// module chunks = 0